import { HorseTipsterModel } from '../../../model/horse/HorseTipsterModel';
import { HorseModel } from '../../../model/horse/HorseModel';
import { HorseTipsPackageModel } from '../../../model/horse/HorseTipsPackageModel';
import { HorseInRaceTipsModel } from '../../../model/horse/HorseInRaceTipsModel';
import { Util } from '../../../util/Util';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { HorseRaceModel } from '../../../model/horse/HorseRaceModel';
import { RaceDistance, RaceCourse, RaceClass, RaceTrack, TrackCondition, Constants, RaceTrackShort } from '../../../util/Constants';
import { HorseBetDataProvider } from '../horse-bet-data/horse-bet-data';
import { HorseNoteModel } from '../../../model/horse/HorseNoteModel';
import { HorsePackagedTipsModel } from '../../../model/horse/HorsePackagedTipsModel';
import { HorseBetInfoModel } from '../../../model/horse/HorseBetInfoModel';
import { Video } from '../../../model/Video';

/*
  Generated class for the HorseDataConverterProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class HorseDataConverterProvider {

  constructor(private horseBetDataProvider: HorseBetDataProvider) {
  }

  public getInRaceTipsModel(horses: Array<HorseModel>, rawRaceTips: any, tipster: HorseTipsterModel): HorseInRaceTipsModel {
    let tipsId = rawRaceTips.id;
    let raceNum = rawRaceTips.dayRaceNo;
    let raceId = rawRaceTips.raceId;
    let tipsPrice = Util.getActualNumber(rawRaceTips.price);
    let tipsNotes = rawRaceTips.note;
    let imgSrc = "";
    if (rawRaceTips.image != null && rawRaceTips.image == "1") {
      imgSrc = Util.getImgUrl(Constants.Enum_ImageType.indexOf("Tips"), tipsId);
    }
    let availableForPurchase = rawRaceTips.availableForPurchase;
    let purchased = rawRaceTips.purchased;
    let voucherCost = rawRaceTips.voucherCost;
    let allowRefund = rawRaceTips.allowRefund;
    let confidenceLevel = rawRaceTips.confidenceLevel;
    let profitMargin = rawRaceTips.tipResult;
    let dividend;
    if (rawRaceTips.dividend == null || rawRaceTips.dividend == "") {
      dividend = -1;
    } else {
      dividend = Util.getActualNumber(rawRaceTips.dividend);
    }
    let createDate = rawRaceTips.createDate;
    if (createDate != null) {
      createDate = createDate.replace(" ", "T")
    }
    let postDate = rawRaceTips.postDate;
    if (postDate != null) {
      postDate = postDate.replace(" ", "T")
    }
    let status = rawRaceTips.status;
    let allowUpdate = rawRaceTips.allowUpdate;

    let wpStrategy = rawRaceTips.wpStrategy;
    let wpHorses = new Array<HorseModel>();
    if (rawRaceTips.wpHorseNo != null) {
      for (let horseNo of rawRaceTips.wpHorseNo) {
        let horse = this.getHorse(horses, raceNum, horseNo);
        if (horse != null) {
          wpHorses.push(horse);
        }
      }
    }

    let qqpStrategy = rawRaceTips.qqpStrategy;
    let qqpBankerHorses = new Array<HorseModel>();
    if (rawRaceTips.qqpBanker != null) {
      for (let horseNo of rawRaceTips.qqpBanker) {
        let horse = this.getHorse(horses, raceNum, horseNo);
        if (horse != null) {
          qqpBankerHorses.push(horse);
        }
      }
    }
    let qqpSelHorses = new Array<HorseModel>();
    if (rawRaceTips.qqpLegs != null) {
      for (let horseNo of rawRaceTips.qqpLegs) {
        let horse = this.getHorse(horses, raceNum, horseNo);
        if (horse != null) {
          qqpSelHorses.push(horse);
        }
      }
    }
    let tmpRaceResultList = rawRaceTips.raceResult;
    if (tmpRaceResultList != null) {
      for (let tmpRaceResult of tmpRaceResultList) {
        for (let tmpWpHorse of wpHorses) {
          if (tmpWpHorse.num == tmpRaceResult.horseNum) {
            tmpWpHorse.finishingOrder = tmpRaceResult.position;
          }
        }

        for (let tmpQQPBankerHorse of qqpBankerHorses) {
          if (tmpQQPBankerHorse.num == tmpRaceResult.horseNum) {
            tmpQQPBankerHorse.finishingOrder = tmpRaceResult.position;
          }
        }

        for (let tmpQQPSelHorse of qqpSelHorses) {
          if (tmpQQPSelHorse.num == tmpRaceResult.horseNum) {
            tmpQQPSelHorse.finishingOrder = tmpRaceResult.position;
          }
        }
      }
    }

    let betInfo = this.horseBetDataProvider.getBetInfo(confidenceLevel, wpStrategy, wpHorses.length, qqpStrategy, qqpBankerHorses.length > 0, qqpSelHorses.length);
    return new HorseInRaceTipsModel(tipsId, raceNum, raceId, tipster, tipsPrice, tipsNotes, availableForPurchase, purchased, voucherCost, allowRefund,
      createDate, postDate, status, wpStrategy, wpHorses, qqpStrategy,
      qqpBankerHorses, qqpSelHorses, confidenceLevel, betInfo, profitMargin, dividend, allowUpdate, imgSrc, rawRaceTips.image1, rawRaceTips.image2, rawRaceTips.image3);
  }

  public getTipsPackageModel(raceCards: Array<HorseRaceModel>, rawTipsPackage: any, tipster: HorseTipsterModel): HorseTipsPackageModel {
    let tipsId = rawTipsPackage.id;
    let tipsPrice = Util.getActualNumber(rawTipsPackage.price);
    let notes = rawTipsPackage.note;
    let imgSrc = "";
    if (rawTipsPackage.image != null && rawTipsPackage.image == "1") {
      imgSrc = Util.getImgUrl(Constants.Enum_ImageType.indexOf("TipsPackage"), tipsId);
    }
    let availableForPurchase = rawTipsPackage.availableForPurchase;
    let allowRefund = rawTipsPackage.allowRefund;
    let purchased = rawTipsPackage.purchased;
    let buyerCount = rawTipsPackage.buyerCount;
    let lastModifiedTime = rawTipsPackage.lastModified;
    let publishEnded = rawTipsPackage.publishEnded;
    let addCommentEnabled = rawTipsPackage.addCommentEnabled;
    let profitMargin = rawTipsPackage.profitMargin;
    let dividend = rawTipsPackage.dividend;
    let packagedTips = new Array<HorsePackagedTipsModel>();
    let createDate = rawTipsPackage.createDate;
    if (createDate != null) {
      createDate = createDate.replace(" ", "T");
    }
    let postDate = rawTipsPackage.postDate;
    if (postDate != null) {
      postDate = postDate.replace(" ", "T");
    }
    let status = rawTipsPackage.status;
    let raceDate = rawTipsPackage.raceDate;
    let voucherCost = rawTipsPackage.voucherCost;
    let keyRaces = new Array<Number>();
    let packageTipsCreateDate = "";
    let packageTipsPostDate = "";
    for (let rawRaceTips of rawTipsPackage.raceTips) {
      let horses = new Array<HorseModel>();
      for (let raceCard of raceCards) {
        if (raceCard.raceId == rawRaceTips.raceId) {
          horses = raceCard.horses;
        }
      }
      let inRaceTips = this.getInRaceTipsModel(horses, rawRaceTips, tipster);
      packageTipsCreateDate = inRaceTips.createDate;
      packageTipsPostDate = inRaceTips.postDate;
      let packagedTip = this.convertInRaceTipsToPackagedTips(inRaceTips);
      packagedTips.push(packagedTip);
      if (inRaceTips.confidenceLevel > 1) {
        keyRaces.push(inRaceTips.raceNum);
      }

    }

    if (createDate == null || createDate == "") {
      createDate = packageTipsCreateDate;
    }

    if (postDate == null || postDate == "") {
      postDate = packageTipsPostDate;
    }

    return new HorseTipsPackageModel(tipsId, tipster, tipsPrice, notes, availableForPurchase, purchased,
      voucherCost, allowRefund, createDate, postDate, status, keyRaces, packagedTips, buyerCount,
      lastModifiedTime, publishEnded, raceDate, addCommentEnabled, profitMargin, dividend, imgSrc, "", "", "");
  }

  public convertInRaceTipsToPackagedTips(inRaceTips: HorseInRaceTipsModel) {
    let tipsId = inRaceTips.id;
    let raceNum = inRaceTips.raceNum;
    let raceId = inRaceTips.raceId;
    let horses = inRaceTips.qqpSelHorses;
    let notes = inRaceTips.notes;
    let keyRace = inRaceTips.confidenceLevel == 2;
    let profitMargin = inRaceTips.profitMargin;
    let dividend = inRaceTips.dividend;
    let countScore = inRaceTips.confidenceLevel != 0;
    let image1 = inRaceTips.image1;
    let image2 = inRaceTips.image2;
    let image3 = inRaceTips.image3;
    return new HorsePackagedTipsModel(tipsId, raceNum, raceId, horses, notes, keyRace, profitMargin, dividend, countScore, image1, image2, image3);
  }

  public convertPackagedTipsToInRaceTips(packagedTip: HorsePackagedTipsModel, tipster: HorseTipsterModel): HorseInRaceTipsModel {
    let tipsId = packagedTip.id;
    let confidenceLevel = packagedTip.keyRace ? 2 : 1;
    let raceNum = packagedTip.raceNum;
    let raceId = packagedTip.raceId;
    let notes = packagedTip.notes;
    let price = 0;
    let purchased = false;
    let availableForPurchase = true;
    let voucherCost = 0;
    let allowRefund = false;
    let wpStrategy = 0;
    let wpHorses = new Array<HorseModel>();
    let qqpStrategy = 0;
    let qqpBankerHorses = new Array<HorseModel>();
    let qqpSelHorses = packagedTip.horses;
    let betInfo = new HorseBetInfoModel(0, "", 0, 0, 0, 0, 0, 0, "", 0, 0, 0, 0, 0, 0);
    let profitMargin = packagedTip.profitMargin;
    let dividend = packagedTip.dividend;
    let createDate = "";
    let postDate = "";
    let status = 0;
    let allowUpdate = true;

    return new HorseInRaceTipsModel(tipsId, raceNum, raceId, tipster, price, notes, availableForPurchase, purchased,
      voucherCost, allowRefund, createDate, postDate, status, wpStrategy, wpHorses, qqpStrategy, qqpBankerHorses,
      qqpSelHorses, confidenceLevel, betInfo, profitMargin, dividend, allowUpdate, "", "", "", "");
  }

  public convertRawDataToRaceCards(rawRaceCards: Array<Object>, bIncludePackage: boolean): Array<HorseRaceModel> {
    let raceCards = new Array<HorseRaceModel>();
    console.log("Raw Race Cards");
    console.log(rawRaceCards);
    for (let tmpRaceCard of rawRaceCards) {
      let raceCard = this.convertRawDataToSingleRaceCard(tmpRaceCard);
      raceCards.push(raceCard);
    }

    if (bIncludePackage && raceCards != null && raceCards.length > 0) {
      raceCards.unshift(new HorseRaceModel(0, 0, raceCards[0].raceName, raceCards[0].raceDistance,
        raceCards[0].raceDate, raceCards[0].raceTime, raceCards[0].raceCourse, raceCards[0].raceClass,
        raceCards[0].raceTrack, raceCards[0].raceTrackCondition, raceCards[0].horses, raceCards[0].hasP, raceCards[0].hasQ, raceCards[0].hasQP, raceCards[0].raceTips, raceCards[0].keyRace));
    }
    return raceCards;
  }

  public convertRawDataToSingleRaceCard(rawRaceCard: any): HorseRaceModel {
    let raceId = rawRaceCard.raceId;
    let raceNum = rawRaceCard.raceNum;
    let raceName = rawRaceCard.raceName;
    let raceDistance = RaceDistance[rawRaceCard.distance];
    let raceDate = rawRaceCard.raceDate;
    let raceTime = rawRaceCard.raceTime != null ? rawRaceCard.raceTime.substring(0, 5) : "";
    let raceCourse = RaceCourse[rawRaceCard.raceCourse];
    let raceClass = RaceClass[rawRaceCard.raceClass];
    // let raceTrack = RaceTrack[rawRaceCard.raceTrack];
    let keyRace = rawRaceCard.keyRace;
    let raceTrack = RaceTrackShort[rawRaceCard.raceTrack];
    let raceTrackCondition = TrackCondition[rawRaceCard.trackCondition];
    let hasP = rawRaceCard.hasP;
    let hasQ = rawRaceCard.hasQ;
    let hasQP = rawRaceCard.hasQp;
    let entryUrl = rawRaceCard.entryUrl;
    let raceUrl = rawRaceCard.raceUrl;
    let bannerUrl = rawRaceCard.bannerUrl;
    let userId = rawRaceCard.userId;
    let code = rawRaceCard.code;
    let firstVideos: Array<Video> = [];
    let raceVidoes: Array<Video> = [];
    let isFav: boolean = rawRaceCard.code == "1";
    let startIdx:number = rawRaceCard.startIdx;

    if (rawRaceCard.FirstVideo != null) {
      for (let firstVideo of rawRaceCard.FirstVideo) {
        firstVideos.push(firstVideo);
      }
    }
    if (rawRaceCard.RaceVideo != null) {
      for (let raceVidoe of rawRaceCard.RaceVideo) {
        raceVidoes.push(raceVidoe);
      }
    }

    let horses = new Array<HorseModel>();
    for (let tmpHorse of rawRaceCard.horses) {
      let horseId = tmpHorse.id;
      let horseCode = tmpHorse.code;
      let horseNum = tmpHorse.horseNum;
      let horseHotLevel = tmpHorse.hotLevel;
      let horseName = tmpHorse.name;
      let horseDraw = tmpHorse.draw;
      let jockeyName = tmpHorse.jockeyName;
      let trainerName = tmpHorse.trainerName;
      let scratched = tmpHorse.scratched;
      let noteCreated = tmpHorse.noteCreated;
      let noteCreatedBefore = tmpHorse.noteCreatedBefore;
      let winOdd = Util.getFormattedOdd(Util.getOddsActualNumber(tmpHorse.winOdd));
      let placeOdd = Util.getFormattedOdd(Util.getOddsActualNumber(tmpHorse.placeOdd));
      let winFavourite = tmpHorse.winFavourite;
      let placeFavourite = tmpHorse.placeFavourite;
      horses.push(new HorseModel(horseId, horseCode, horseNum, horseName, horseDraw, horseHotLevel,
        jockeyName, trainerName, scratched, false, false, false, noteCreated, noteCreatedBefore, -1, 
        winOdd, placeOdd, winFavourite, placeFavourite));
    }



    let raceTips = new Array<HorseInRaceTipsModel>();
    let tmpRaceTips = rawRaceCard.RaceTip;

    if (tmpRaceTips != null && tmpRaceTips.length > 0) {
      for (let tmpRaceTip of tmpRaceTips) {
        let tipsterId = tmpRaceTip.userId;
        let tipster = new HorseTipsterModel(tipsterId, "", "", "", "", "", 0, 0, 0, "", "", "", "", 0, 0, 0, 0, 0, "", "", 0, 0, -1, 0);
        tmpRaceTip.dayRaceNo = raceNum; // as server does not feed the dayRaceNo, we need to set it manually
        let raceTip = this.getInRaceTipsModel(horses, tmpRaceTip, tipster);
        raceTips.push(raceTip);
      }
    }

    return new HorseRaceModel(raceId, raceNum, raceName, raceDistance, raceDate, raceTime,
      raceCourse, raceClass, raceTrack, raceTrackCondition, horses, hasP, hasQ, hasQP, raceTips,keyRace,
      entryUrl, raceUrl, bannerUrl, userId,firstVideos, raceVidoes, code, isFav, startIdx);
  }

  private getHorse(horses: Array<HorseModel>, raceNum: number, horseNum: number): HorseModel {
    //let raceCards = this.customStorageProvider.get<Array<HorseRaceModel>>(Constants.STORAGE_KEY_RACE_CARDS);
    //for (let raceCard of raceCards) {
    //if (raceCard.raceNum == raceNum) {
    for (let horse of horses) {
      if (horse.num == horseNum) {
        return horse;
      }
    }
    //}
    // }
    return new HorseModel(0, "", 0, "", 0, 0, "", "", false);
  }

  public convertRawDataToNotes(rawNote: any): Array<HorseNoteModel> {
    let alNotes = new Array<HorseNoteModel>();
    let horse = rawNote.Horse;
    for (let tmpNote of rawNote.RacingNote) {
      let notes = tmpNote.notes;
      let options = tmpNote.racingNoteOptions;
      let raceCard = this.convertRawDataToSingleRaceCard(tmpNote.RaceCard);
      let id = tmpNote.id;
      alNotes.push(new HorseNoteModel(id, raceCard, horse, options, notes))
    }
    return alNotes;
  }

  public convertRawDataToNoteHorses(rawNote: any): Array<HorseModel> {
    let alHorses = new Array<HorseModel>();
    for (let tmpNote of rawNote.HorseRacingNote) {
      alHorses.push(new HorseModel(tmpNote.Horse.id, tmpNote.Horse.code, 0, tmpNote.Horse.name, 0, 0, "", "", false, false, false, false, false, false));
    }
    return alHorses;
  }

  public convertRawDataToTipster(rawTipsterInfo: any) {
    let tipsterId = rawTipsterInfo.id;
    let tipsterNickname = rawTipsterInfo.nickname;
    let tipsterInRaceTipsRanking = Util.getConvertedRanking(rawTipsterInfo.ranking);
    let tipsterInRaceTipsScore = Util.getActualNumber(rawTipsterInfo.tipScore);
    let tipsterInRaceTipsProfitability = rawTipsterInfo.profitability;
    if (tipsterInRaceTipsProfitability == "99999999") {
      tipsterInRaceTipsProfitability = "0";
    }
    let tipsterInRaceTipsAccuracy = rawTipsterInfo.accuracy;
    let tipsterInRaceTipsTotalSoldCount = rawTipsterInfo.buyerCount;
    let tipsterInRaceTipsProfitabilityRanking = rawTipsterInfo.profitabilityRanking;
    let tipsterInRaceTipsAccuracyRanking = rawTipsterInfo.accuracyRanking;
    let tipsterTipsPackageRanking = Util.getConvertedRanking(rawTipsterInfo.packageRanking);
    let tipsterTipsPackageScore = Util.getActualNumber(rawTipsterInfo.packageTipScore);
    let tipsterTipsPackageProfitability = rawTipsterInfo.packageProfitability;
    let tipsterTipsPackageAccuracy = rawTipsterInfo.packageAccuracy;
    let tipsterTipsPackageProfitabilityRanking = rawTipsterInfo.packageProfitabilityRanking;
    let tipsterTipsPackageAccuracyRanking = rawTipsterInfo.packageAccuracyRanking;
    let tipsterTipsPackageTotalSoldCount = rawTipsterInfo.packageBuyerCount;
    let tipsterDefaultTipsPrice = Util.getActualNumber(rawTipsterInfo.price);
    let tipsterDefaultTipsPackagePrice = Util.getActualNumber(rawTipsterInfo.packagePrice);
    let biographyTitle = rawTipsterInfo.biographyTitle;
    let biographyDetail = rawTipsterInfo.biographyDetail;
    let subscribeType = rawTipsterInfo.subscribeType;
    let subscriberType = rawTipsterInfo.subscriberType;
    let highestScore = Util.getActualNumber(rawTipsterInfo.highestScore);
    let currentProfitMargin = Util.getActualNumber(rawTipsterInfo.currentProfitMargin);

    let tipster = new HorseTipsterModel(tipsterId, tipsterNickname, tipsterInRaceTipsRanking, tipsterInRaceTipsScore.toString(), tipsterInRaceTipsProfitability,
      tipsterInRaceTipsAccuracy, tipsterInRaceTipsTotalSoldCount, tipsterInRaceTipsProfitabilityRanking, tipsterInRaceTipsAccuracyRanking,
      tipsterTipsPackageRanking, tipsterTipsPackageScore.toString(), tipsterTipsPackageProfitability, tipsterTipsPackageAccuracy,
      tipsterTipsPackageTotalSoldCount, tipsterTipsPackageProfitabilityRanking, tipsterTipsPackageAccuracyRanking, tipsterDefaultTipsPrice,
      tipsterDefaultTipsPackagePrice, biographyTitle, biographyDetail,
      subscribeType, subscriberType, highestScore, currentProfitMargin);
    return tipster;
  }
}



// WEBPACK FOOTER //
// ./src/providers/horse/horse-data-converter/horse-data-converter.ts